import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "../Navbar.css";
import logo from "../assets/logo.png";

function NavigationBar() {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  // Function to update cart count from localStorage
  const updateCartCount = () => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser && Array.isArray(storedUser.Cart)) {
      setCartCount(storedUser.Cart.length);
    } else {
      setCartCount(0);
    }
  };

  useEffect(() => {
    const updateCartCount = () => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      setCartCount(storedUser?.Cart?.length || 0);
    };
  
    updateCartCount(); // Initial cart count on page load
  
    // Listen for "cartUpdated" event
    window.addEventListener("cartUpdated", updateCartCount);
  
    return () => {
      window.removeEventListener("cartUpdated", updateCartCount);
    };
  }, []);
  

  useEffect(() => {
    updateCartCount(); // Initial cart count on page load

    // Listen for localStorage changes to detect cart updates
    const handleStorageChange = (event) => {
      if (event.key === "user") {
        updateCartCount();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Sticky Navbar Logic
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Mobile resize handler
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setMenuOpen(false); // Close menu on resize if screen is large enough
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <nav className={`navbar ${isSticky ? "sticky" : ""}`}>
      <div className="nav-content">
        {/* Left Section: Logo + Home Button */}
        <div className="navbar-left">
          <Link to="/" className="logo-link">
            <img src={logo} alt="PharmPrepPro Logo" className="navbar-logo" />
          </Link>
          <Link to="/" className="home-link">PharmPrepPro</Link>
        </div>

        {/* Hamburger Menu (Only for mobile) */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* Desktop Navigation */}
        <ul className={`nav-links ${isMobile ? "hidden" : ""}`}>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/faq">FAQ</Link></li>
          <li><Link to="/courses">Study Guides</Link></li>
          <li><Link to="/practicequestions">Practice Questions</Link></li>
          <li><Link to="/practice-test">Practice Test</Link></li>
          <li><Link to="/products">Products</Link></li>

          {/* Login Icon */}
          <li className="nav-icons">
            <Link to="/login" className="icon-wrapper">
              <img
                src="https://cdn-icons-png.flaticon.com/512/456/456283.png"
                alt="Login Icon"
                className="login-icon"
              />
            </Link>
          </li>

          {/* Cart Icon with Badge */}
          <li className="nav-icons">
            <div className="cart-container">
              <Link to="/cart" className="icon-wrapper">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/833/833314.png"
                  alt="Cart Icon"
                  className="cart-icon"
                />
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </Link>
            </div>
          </li>
        </ul>

        {/* Mobile Menu (Only shows when hamburger is clicked) */}
        {isMobile && (
          <ul className={`mobile-menu ${menuOpen ? "open" : "closed"}`}>
            <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
            <li><Link to="/faq" onClick={() => setMenuOpen(false)}>FAQ</Link></li>
            <li><Link to="/courses" onClick={() => setMenuOpen(false)}>Study Guides</Link></li>
            <li><Link to="/practicequestions">Practice Questions</Link></li>
            <li><Link to="/practice-test" onClick={() => setMenuOpen(false)}>Practice Test</Link></li>
            <li><Link to="/products" onClick={() => setMenuOpen(false)}>Products</Link></li>
            <li><Link to="/login" onClick={() => setMenuOpen(false)}>Login</Link></li>
            <li><Link to="/cart" onClick={() => setMenuOpen(false)}>Cart</Link></li>
          </ul>
        )}
      </div>
    </nav>
  );
}

export default NavigationBar;
